module.exports = __webpack_public_path__ + "img/6.5d50813.svg";